<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-app-bar
      app
      color="secondary"
      class="px-4"
      dense
      flat
    >
      <v-btn
        text
        class="d-flex align-center"
        v-on:click="$router.replace({name: 'Mixer'})"
      >
        <v-img
          alt="FN Ink Logo"
          class="shrink ml-2"
          src="../assets/logo_black.png"
          transition="scale-transition"
          width="100"
        />
        <v-divider
        class="mx-3 appBarDivider hidden-sm-and-down"
        vertical
      ></v-divider>
        <span class="mtfont appBarLogo hidden-sm-and-down">MIXING SYSTEM</span>
      </v-btn>

      <v-spacer></v-spacer>

      <!-- TODO :: Why Only Works Outside of Menu -->
      <NewFormulaModal v-if="!$route.path.includes('admin')"/>
      <!-- TODO :: Why Only Works Outside of Menu -->

      <span>
          <v-menu >
          <template v-slot:activator="{ on, attrs }">
              <v-btn
                      icon
                      dense
                      v-bind="attrs"
                      v-on="on"
              >
                  <v-icon color="black">menu</v-icon>
              </v-btn>
          </template>
          <v-list>
            <!--
              <v-list-item v-if="!$route.path.includes('admin')">
                  <NewFormulaModal/>
              </v-list-item>
            -->
              <v-list-item
                  v-if="!$route.path.includes('admin') && !$route.path.includes('login')"
              >
                  <v-btn
                          class="mtfont"
                          v-on:click="$router.push({name: 'Admin'})"
                          text
                  >
                      <span v-if="$store.getters.loggedIn">ACCOUNT</span>
                      <span v-else>LOGIN</span>
                  </v-btn>
              </v-list-item>
            <v-list-item
                v-if="$store.getters.loggedIn"
            >
              <v-btn
                  class="mtfont"
                  v-on:click="logout"
                  text
              >
                LOGOUT
              </v-btn>
            </v-list-item>
          </v-list>
      </v-menu>
      </span>


          <!--<NewFormulaModal class="hidden-sm-and-down" v-if="!$route.path.includes('admin')"/>
              <v-btn
                          v-if="!$route.path.includes('admin') && !$route.path.includes('login')"
                          class="mtfont hidden-sm-and-down"
                          v-on:click="$router.push({name: 'Admin'})"
                          text
                  >
                    <span >ACCOUNT</span>
              </v-btn> -->
    </v-app-bar>
</template>

<script>
  import NewFormulaModal from '@/components/NewFormulaModal.vue';

  export default {
    name: 'NavBar',
    props: ['page'],

    data: () => ({
    }),
    components: {
      NewFormulaModal
    },
    methods: {
      logout: function(event) {
        this.$store.dispatch('destroyToke');
        this.$router.push({name: 'Login'})
      }
    }
  }
</script>

<style scoped>
</style>